
define(
	'NVT.EventCalendarExt.MyEventModule'
,   [
		'NVT.EventCalendarExt.MyEventModule.View'
	]
,   function (
		MyEventModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

			/** @type {LayoutComponent} */
			
			var layout = container.getComponent('PLP');

			if(layout)
			{
				layout.addChildView('cust-event-calender-view', function() {
					return new MyEventModuleView({ container: container });
				});
			}
		}
	};
});
